<div #map
     class="map"
>
</div>
